export default __webpack_public_path__ + "static/media/tl3.fc9caa9c.webp";